import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
  pushStatisticDetail: state => state.pushStatisticDetail,
  pushStatisticGroup: state => state.pushStatisticGroup,
  pushGroupBy: state => state.pushGroupings.pushGroup,
  pushGroupByOptionally: state => state.pushGroupings.pushGroupOptionally,
  pushSubscribers: state => state.pushSubscribers || [],
  pushHistories: state => state.pushHistories || [],
};